import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-download-qr',
  templateUrl: './download-qr.component.html',
  styleUrls: ['./download-qr.component.scss'],
})
export class DownloadQrComponent implements OnInit {

  @Input() link: string;
  @Input() vegname: string;
  @Input() vegetationId: string;

  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void { 

    // window.open(this.link, '_blank');
  }
}
